<kendo-dialog class="{{type}}" *ngIf="opened"
              [title]="title"
              [width]="width"
              [height]="'80%'"
              (close)="close('close')"

>
    <ul class="listitem">
        <li (click)="close(invoice)" *ngFor="let invoice of list" class="la pointer">
            {{invoice.invoiceDate}}    -   {{invoice.invoiceNumber}}  - ${{invoice.invoiceTotal}}
        </li>
    </ul>

    <kendo-dialog-actions>
        <button kendoButton (click)="close('close')">Cancel</button>
    </kendo-dialog-actions>
</kendo-dialog>
<div kendoDialogContainer></div>
